import Vue from 'vue'
import VueAxios from 'vue-axios'
import store from './store'
import router from './router'
import EventBus from './bus'
import LogRocket from 'logrocket';
import service from './service/service'
import api from './service/api'
import moment from 'moment'
import * as axios from "axios"
import './pollyfills'
import 'es6-promise/auto'
import {version} from '../package.json';

var baseURL = null
switch(process.env.NODE_ENV) {
  case 'preprod':
    baseURL = 'https://api-preprod.qualificationcheck.com/v1'
    break
  case 'sandbox':
    baseURL = 'https://api-sandbox.qualificationcheck.com/v1'
    break
  case 'production':
    baseURL = 'https://api.qualificationcheck.com/v1'
    break
  default:
    baseURL = 'http://localhost:8081/v1'
}
var instance = axios.create({
    baseURL: baseURL,
    timeout: 300000,
});

Vue.use(VueAxios, instance)

instance.interceptors.request.use(
  function (config) {
    config.headers['X-Client-Type'] = 'WEB'
    if(store.state.token) {
      config.headers['X-AUTH-TOKEN'] = store.state.token
    } else if(store.state.publicToken) {
      config.headers['X-AUTH-TOKEN'] = store.state.publicToken
    }
    if($cookies.get('X-QC-ADMIN')) {
      config.headers['X-QC-ADMIN'] = $cookies.get('X-QC-ADMIN')
      store.state.qcAdmin = true;
    }
    if(store.state.applicationInProgress) {
      config.headers['X-QC-APPL-ID'] = store.state.applicationInProgress  
    }
    if(!config.headers['X-REFRESH-TOKEN'] && moment().isAfter(store.state.expiry) && moment().isBefore(store.state.autoLogout)) {
      let orgRequest = config
      return api.refreshLogin()
        .then(response => {
          config.headers['X-AUTH-TOKEN'] = store.state.token
          return Promise.resolve(orgRequest)
        })
        .catch(error => {
          var status = ((error||{}).response||{}).status
          if(status == 'QC-CANTREFRESH') {
            EventBus.$emit('error', "Session expired.")
          } else if(status != 401) {
            console.log(error)
            EventBus.$emit('error', "An unknown error occurred trying to keep your session alive, please try again or report this error.")
          }
          store.commit('logout')
          router.push('/login?expired=true')
          return Promise.reject(error)
        })
    }
    return config
  }, 
function (error) {
  console.log(error)
  return Promise.reject(error);
})

instance.interceptors.response.use(
  function (response) {
    return response
  }, 
  function (error) {
    var message
    if (error.response) {
      if(error.response.data) {
        if(error.response.data.errors) {
          for (let i = 0; i < error.response.data.errors.length; i++) {
            EventBus.$emit('error', error.response.data.errors[i].message)
          }
        }
      }
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      if(error.config.skipErrorHandler) {
        return Promise.reject(error)
      }
      message = error.response.data.message
      console.log(error.response)
    } else if (error.request) {
      // The request was made but no response was received
      if(error.config.docUpload) {
        message = 'Request timed out after 5 minutes.'
        EventBus.$emit('docUploadError')
      } else {
        message = 'Server communication failure, request timed out after 60 seconds. Please try again or report this error.'
      }
      console.log(JSON.stringify(error))
    } else {
      // There was an error sending the request
      message = error.message
      console.log(error.response)
    }
    EventBus.$emit('error', message)
    LogRocket.captureException(error)
    return Promise.reject(message)
  })

export default instance